var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header" },
    [
      _vm._t("collapseBtn"),
      _c("div", { staticClass: "logo" }, [
        _c("img", {
          staticClass: "logo-icon",
          attrs: {
            src: require("@/assets/img/icon-kpmglogo.svg"),
            width: "100%",
          },
        }),
        _c("span", [_vm._v(_vm._s(_vm.$t("COMMON_PROJECT_NAME")))]),
      ]),
      _c("div", { staticClass: "header-right" }, [
        _c("div", { staticClass: "header-user-con" }, [
          _c(
            "div",
            { staticClass: "btns" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: { placement: "bottom" },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.fullscreen
                                  ? _vm.$t("full_no_screen")
                                  : _vm.$t("full_screen")
                              ) +
                              " "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        staticStyle: { display: "flex" },
                        on: { click: _vm.handleFullScreen },
                      },
                      [
                        _vm.fullscreen
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/img/icon-Exit-fullscreen.svg"),
                                width: "100%",
                              },
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/img/icon-fullscreen.svg"),
                                width: "100%",
                              },
                            }),
                      ]
                    ),
                  ],
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("configTimeoutDialogTitle"),
            visible: _vm.timeoutVisible,
            width: "20%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.timeoutVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "center" },
            [
              _c("el-input-number", {
                attrs: { precision: 1, step: 0.5, max: 8, min: 0.5 },
                model: {
                  value: _vm.outTime,
                  callback: function ($$v) {
                    _vm.outTime = $$v
                  },
                  expression: "outTime",
                },
              }),
              _vm._v(
                "\n            " + _vm._s(_vm.$t("hour")) + "\n            "
              ),
              _c(
                "div",
                {
                  staticClass: "tip",
                  staticStyle: { color: "#fd349c", "text-align": "left" },
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("outTimeTips")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setOutTime } },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm.supportVisible
        ? _c("contact-us", {
            attrs: {
              onCancel: _vm.toogleSupportVisible,
              account: _vm.getUser.userAccount,
            },
          })
        : _vm._e(),
      _vm.videoListShow
        ? _c("short-videos", { attrs: { onCancel: _vm.toogleVideoShow } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }